import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { ActorListItem } from '@match-fix/shared';
import { AgEditorComponent } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

@Component({
  selector: 'select-actor-cell-editor',
  templateUrl: './select-actor-cell-editor.component.html',
  styleUrls: ['./select-actor-cell-editor.component.scss']
})
export class SelectActorCellEditorComponent implements AgEditorComponent, AfterViewInit {
  @ViewChild('select') select: MatSelect;

  public value: ActorListItem;
  public params: ICellEditorParams;

  getValue() {
    return this.value;
  }

  agInit(params: ICellEditorParams) {
    this.params = params;
    this.value = params.data[params.colDef.field];
  }

  ngAfterViewInit() {
    window.setTimeout(() => this.select.open());
  }

  public onChange(event) {
    this.params.data.deficiencyTypeId = null;
    this.value = event.value;

    this.params.api.stopEditing();
  }
}